import { OverViewWrapper, DesktopOverviewContainer, WhitePaperContainer } from '../styled'
import React from 'react'
import {
  ContentColumn,
  ContentContainer,
  SkeletonWrapper,
  SplashContentDescription,
  OverViewSplash,
  SplashContainer,
} from '../pages/splash/style'
import Skeleton from 'react-loading-skeleton'
import {
  HeaderContainer,
  MarketCapHeader,
  PerformanceContainer,
  PerformanceHeaders,
  PerformanceListWrapper,
  ProductDetails,
  PerformancePageWrapper,
  MarketDetails,
  PerformanceItem,
  ProductNameAndDescription,
} from '../pages/exposure/style'
import {
  ProductsPromoContainer,
  SmartProductItem,
  SmartProductsList,
  SmartSecureProducts,
} from '../pages/smart-products/style'
import { NumbersContainer } from '../pages/number-container/style'
import { StyledImageWrapper } from './styled'

export const DesktopOverviewLoading: React.FC = () => {
  return (
    <OverViewWrapper>
      <DesktopOverviewContainer>
        {/* <!-- Splash loading --> */}
        <OverViewSplash>
          <SplashContainer>
            <ContentContainer>
              <ContentColumn>
                <SkeletonWrapper>
                  <Skeleton width={352} height={48} />
                  <Skeleton width={300} height={48} />
                </SkeletonWrapper>
                <SplashContentDescription>
                  <SkeletonWrapper>
                    <Skeleton width={352} height={16} />
                    <Skeleton width={280} height={16} />
                  </SkeletonWrapper>
                </SplashContentDescription>
                <SkeletonWrapper>
                  <Skeleton width={152} height={40} borderRadius="1.5rem" />
                </SkeletonWrapper>
              </ContentColumn>
              <ContentColumn>
                <SkeletonWrapper>
                  <Skeleton width={415} height={215} borderRadius="1.5rem" />
                </SkeletonWrapper>
              </ContentColumn>
            </ContentContainer>
          </SplashContainer>
        </OverViewSplash>
        <StyledImageWrapper>
          <Skeleton width={1160} height={137} borderRadius="4.5rem" />
        </StyledImageWrapper>
        {/* <!-- Product exposure loading --> */}
        <PerformancePageWrapper>
          <SplashContainer>
            <PerformanceContainer id="content">
              <SkeletonWrapper>
                <Skeleton width={280} height={36} />
                <Skeleton width={320} height={36} />
              </SkeletonWrapper>
              <PerformanceListWrapper>
                <PerformanceHeaders>
                  <ProductDetails />
                  <MarketCapHeader>
                    <Skeleton width={70} />
                  </MarketCapHeader>
                  <HeaderContainer>
                    <Skeleton width={70} />
                  </HeaderContainer>
                </PerformanceHeaders>
                <PerformanceItem>
                  <ProductDetails>
                    <SkeletonWrapper>
                      <Skeleton circle={true} height={48} width={48} />
                    </SkeletonWrapper>
                    <ProductNameAndDescription>
                      <div>
                        <Skeleton width={300} />
                      </div>
                      <div>
                        <Skeleton width={250} />
                      </div>
                    </ProductNameAndDescription>
                  </ProductDetails>
                  <MarketDetails>
                    <Skeleton width={70} />
                  </MarketDetails>
                  <MarketDetails>
                    <Skeleton width={70} />
                  </MarketDetails>
                  <MarketDetails>
                    <Skeleton width={100} />
                  </MarketDetails>
                  <MarketDetails>
                    <Skeleton width={70} height={30} borderRadius="1.35rem" />
                  </MarketDetails>
                </PerformanceItem>
                <PerformanceItem>
                  <ProductDetails>
                    <SkeletonWrapper>
                      <Skeleton circle={true} height={48} width={48} />
                    </SkeletonWrapper>
                    <ProductNameAndDescription>
                      <div>
                        <Skeleton width={300} />
                      </div>
                      <div>
                        <Skeleton width={250} />
                      </div>
                    </ProductNameAndDescription>
                  </ProductDetails>
                  <MarketDetails>
                    <Skeleton width={70} />
                  </MarketDetails>
                  <MarketDetails>
                    <Skeleton width={70} />
                  </MarketDetails>
                  <MarketDetails>
                    <Skeleton width={100} />
                  </MarketDetails>
                  <MarketDetails>
                    <Skeleton width={70} height={30} borderRadius="1.35rem" />
                  </MarketDetails>
                </PerformanceItem>
                <PerformanceItem>
                  <ProductDetails>
                    <SkeletonWrapper>
                      <Skeleton circle={true} height={48} width={48} />
                    </SkeletonWrapper>
                    <ProductNameAndDescription>
                      <div>
                        <Skeleton width={300} />
                      </div>
                      <div>
                        <Skeleton width={250} />
                      </div>
                    </ProductNameAndDescription>
                  </ProductDetails>
                  <MarketDetails>
                    <Skeleton width={70} />
                  </MarketDetails>
                  <MarketDetails>
                    <Skeleton width={70} />
                  </MarketDetails>
                  <MarketDetails>
                    <Skeleton width={100} />
                  </MarketDetails>
                  <MarketDetails>
                    <Skeleton width={70} height={30} borderRadius="1.35rem" />
                  </MarketDetails>
                </PerformanceItem>
              </PerformanceListWrapper>
            </PerformanceContainer>
          </SplashContainer>
        </PerformancePageWrapper>
        {/* <!-- whitepaper loading --> */}
        <WhitePaperContainer>
          <SkeletonWrapper>
            <Skeleton width={'100%'} height={316} />
          </SkeletonWrapper>
        </WhitePaperContainer>
        {/* <!-- smart products loading --> */}
        <SmartSecureProducts>
          <SkeletonWrapper>
            <Skeleton width={350} height={36} />
          </SkeletonWrapper>
          <SmartProductsList>
            <SmartProductItem>
              <ProductsPromoContainer>
                <Skeleton width={157} height={100} />
              </ProductsPromoContainer>
              <div>
                <Skeleton width={157} />
                <Skeleton width={25} />
              </div>
            </SmartProductItem>
            <SmartProductItem>
              <ProductsPromoContainer>
                <Skeleton width={157} height={100} />
              </ProductsPromoContainer>
              <div>
                <Skeleton width={157} />
                <Skeleton width={75} />
              </div>
            </SmartProductItem>
            <SmartProductItem>
              <ProductsPromoContainer>
                <Skeleton width={157} height={100} />
              </ProductsPromoContainer>
              <div>
                <Skeleton width={145} />
                <Skeleton width={157} />
              </div>
            </SmartProductItem>
          </SmartProductsList>
        </SmartSecureProducts>
        <StyledImageWrapper>
          <Skeleton width={1160} height={137} borderRadius="4.5rem" />
        </StyledImageWrapper>
        {/* <!-- in the numbers loading --> */}
        <NumbersContainer>
          <div>
            <Skeleton width={320} height={36} />
          </div>
          <SmartProductsList>
            <SmartProductItem>
              <Skeleton width={157} height={40} />
              <Skeleton width={157} />
            </SmartProductItem>
            <SmartProductItem>
              <Skeleton width={157} height={40} />
              <Skeleton width={157} />
            </SmartProductItem>
            <SmartProductItem>
              <Skeleton width={157} height={40} />
              <Skeleton width={157} />
            </SmartProductItem>
          </SmartProductsList>
        </NumbersContainer>
      </DesktopOverviewContainer>
    </OverViewWrapper>
  )
}
